import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles((theme) => ({
  highlightBox: {
    position: 'absolute',
    color: '#0f4279',
  },
}));

const HighlightBox = (props) => {
  const classes = useStyles();
  const [boundingBox, setBoundingBox] = useState(null);
  useEffect(() => {
    setBoundingBox(props.boundingBox);
  }, [props.boundingBox]);
  if (boundingBox) {
    let width = boundingBox.right - boundingBox.left - 4;
    let height = boundingBox.bottom - boundingBox.top - 4;
    return (
      <Box
        border={3}
        borderRadius={'borderRadius'}
        className={classes.highlightBox}
        style={{
          width: width,
          height: height,
          top: boundingBox.top + window.pageYOffset + 2,
          left: boundingBox.left + window.pageXOffset + 2,
        }}
      />
    );
  }
  return <div></div>;
};

export default HighlightBox;
